import Vue from "vue"
import VueI18n from "vue-i18n"
import Cookies from "js-cookie"
import { merge } from "lodash"
import { getTenantId } from "@/plugins/env"
import commonEN from "@/assets/lang/en"
import commonZH from "@/assets/lang/zh"
import coldStorageEN from "@/assets/lang/coldStorage/en"
import coldStorageZH from "@/assets/lang/coldStorage/zh"

if (!Vue.__use_i18n__) {
  Vue.__use_i18n__ = true
  Vue.use(VueI18n)
}

export function getLanguage(app) {
  // if (process.server) {
  //   return app.$cookies.get("superweb-locale") || "en_US"
  // } else {
  //   return Cookies.get("superweb-locale") || "en_US"
  // }
  return "en_US"
}

let i18n

export const translate = function (key, params) {
  return (i18n && i18n.t(key, params)) || key
}

export default ({ app }) => {
  let en = commonEN
  let zh = commonZH
  const tenantId = getTenantId()
  switch (tenantId) {
    case 10:
      en = merge(commonEN, coldStorageEN)
      zh = merge(commonZH, coldStorageZH)
      break
    default:
      break
  }
  i18n = new VueI18n({
    locale: getLanguage(app),
    messages: {
      en_US: en,
      zh_HK: zh
    }
  })
  app.i18n = i18n
}
